import React from "react";
import { useTranslation } from "react-i18next";

import { PARTNER_PORTAL_LOGIN_URL } from "../../../constants/urls";
import TextModal from "./TextModal";

function InvalidCustomerTypeLoginModal({
  hideModal,
}) {
  const [t] = useTranslation();

  return (
    <TextModal
      title={t("invalid_login_modal.title")}
      text={(
        <div className="flex flex-col">
          <p className="text-dark text-md">
            {t("invalid_login_modal.this_are_is_reserved_for_customers")}
          </p>

          <p className="text-dark text-md mt-2">
            {t("invalid_login_modal.to_view_the_dealer_portal")}

            {" "}

            <a
              className="text-secondary font-bold cursor-pointer"
              href={PARTNER_PORTAL_LOGIN_URL || ""}
              rel="noopener noreferrer"
              onClick={() => hideModal()}
              target="_blank"
            >
              {t("invalid_login_modal.partner_portal")}
            </a>
          </p>
        </div>
      )}
    />
  );
}

export default InvalidCustomerTypeLoginModal;
